import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConnectionStatusService {
  private connectionPoller: ConnectionPoller;

  constructor(http: HttpClient) {
    this.connectionPoller = new ConnectionPoller(http);
    if (!environment.disableConnectivityChecks) {
      this.connectionPoller.startPoll();
    }
  }

  public getConnectionStatusSubject(): BehaviorSubject<boolean> {
    return this.connectionPoller.connectionStatusSubject;
  }
}

class ConnectionPoller {
  private static POLL_URL = '/api/connectivity';
  private static POLL_INTERVAL = 5000; // 5 seconds

  connectionStatusSubject = new BehaviorSubject<boolean>(true);

  constructor(private http: HttpClient) {}

  startPoll() {
    this.doPoll();
  }

  async doPoll(): Promise<void> {
    this.http
      .head(ConnectionPoller.POLL_URL, { observe: 'response' })
      .subscribe(
        (res: any) => {
          this.connectionStatusSubject.next(res != null && res.status === 204);
          setTimeout(() => this.doPoll(), ConnectionPoller.POLL_INTERVAL);
        },
        (err) => {
          this.connectionStatusSubject.next(false);
          setTimeout(() => this.doPoll(), ConnectionPoller.POLL_INTERVAL);
        }
      );
  }
}
